import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';
import { IPlanDetails } from 'interfaces/plan.interface';

export interface IFetchPlansState {
  state: QueryState;
  plans: IPlanDetails[];
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const FetchPlansEmptyState: IFetchPlansState = {
  state: QueryState.UNDEFINED,
  plans: [],
  error: null,
  accessToken: undefined
};
